import React, { useCallback, useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { client } from "../../../App";
import { convertTime, handlerErrors } from "../../../helpers/helpers";
import {
  GET_CONSUMPTION,
  GET_DASHBOARD_CONSUMPTIONS_AS_XLS,
} from "../../../helpers/queries";
import { ContractDetailReq } from "../../../models/Contract";
import { hideLoading, showLoading } from "../../../reducers/app";
import { setLoadChart } from "../../../reducers/contracts";
import ContractsSelect from "../../common/ContractsSelect/ContractsSelect";
import DataTable from "../../common/DataTable/DataTable";
import Hero from "../../common/Hero/Hero";
import NoResult from "../../common/NoResult/NoResult";
import ConsumeChart from "../../Dashboard/Chart/ConsumeChart";
import "./ViewUsages.scss";

const ViewUsages = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  let loadChart = useSelector((state: any) => state.contracts.loadChart);
  let selectedContract = useSelector((state: any) => state.contracts.current);
  let telemeter = useSelector((state: any) => state.contracts.telemeter);

  const [contracts, setContract] = useState<any>([]);
  const [counterData, setCounterData] = useState<any>([]);
  const [listContract, setListContract] = useState<any>([]);
  const [, setGenericError] = useState<any>(null);
  const columns = [
    {
      Header: t("usage.invoiceNumber"),
      accessor: "invoiceNumber",
      id: "invoiceNumber",
    },
    { Header: t("usage.startDate"), accessor: "startDate", id: "startDate" },
    {
      Header: t("usage.consumption"),
      accessor: "consumption",
      id: "consumption",
    },
    {
      Header: t("usage.metreReadingStatus"),
      accessor: "metreReadingStatus",
      id: "metreReadingStatus",
    },
    {
      Header: t("usage.serialNumber"),
      accessor: "serialNumber",
      id: "serialNumber",
    },
  ];

  const [showPopup, setShowPopup] = useState<any>(false);

  const [key, setKey] = useState("grafico consumi");

  const setTabsKey = useCallback((k: string | null) => {
    if (k) setKey(k);
  }, []);

  useEffect(() => {
    if (!loadChart) {
      if (telemeter) {
        setTabsKey("grafico consumi");
        dispatch(setLoadChart(true));
      } else {
        setTabsKey("consumi fatturati");
      }
    }
  }, [loadChart, dispatch, telemeter, setTabsKey]);

  useEffect(() => {
    if (selectedContract) {
      client()
        .query({
          query: GET_CONSUMPTION,
          variables: ContractDetailReq(selectedContract.id),
        })
        .then(({ data }: { data: any }) => {
          let contractDetail = data.contractDetail;
          let counterHeader = [];
          if (contractDetail) {
            setContract([contractDetail]);
            for (const key in contractDetail.metre) {
              if (key !== "consumptions" && key !== "__typename") {
                counterHeader.push({
                  label: t(`usage.${key}`),
                  data: contractDetail.metre[key],
                });
              }
            }
            setCounterData(counterHeader);
          }
        })
        .catch((error: any) => {
          handleFormErrors(error);
        });
    }
  }, [selectedContract, setTabsKey, t]);

  const getmetreReadingStatus = useCallback(
    (status: any) => {
      switch (status) {
        case "A":
          return t("usages.bill.type.acconto");
        case "S":
          return t("usages.bill.type.saldo");
        case "C":
          return t("usages.bill.type.misto");
        case "R":
          return t("usages.bill.type.rettifica");
        default:
          return "-";
      }
    },
    [t]
  );

  useEffect(() => {
    if (contracts.length > 0) {
      let arrayContractDetails =
        contracts[0]["metre"]["consumptions"]["elements"];
      let contractCode = contracts[0]["metre"]["serialNumber"];
      const formated = arrayContractDetails.map(
        ({
          invoiceNumber,
          startDate,
          endDate,
          initialMetreReading,
          finalMetreReading,
          consumption,
          serialNumber,
          metreReadingStatus,
        }: {
          invoiceNumber: any;
          startDate: any;
          endDate: any;
          initialMetreReading: any;
          finalMetreReading: any;
          consumption: any;
          serialNumber: any;
          metreReadingStatus: any;
        }) => {
          return {
            invoiceNumber: invoiceNumber,
            startDate: convertTime(startDate) + "  -  " + convertTime(endDate),
            // initialMetreReading: initialMetreReading,
            // finalMetreReading: finalMetreReading,
            consumption: consumption,
            serialNumber: contractCode,
            metreReadingStatus: getmetreReadingStatus(metreReadingStatus),
          };
        }
      );
      setListContract(formated);
      dispatch(hideLoading());
    } else {
      dispatch(hideLoading());
    }
  }, [contracts, getmetreReadingStatus, dispatch, t]);

  const handleFormErrors = (e: any) => {
    if (e === null) {
      setGenericError(null);
      return;
    }
    console.log(e.message);
    handlerErrors(e, setGenericError, setGenericError);
  };

  const handleExportExcel = async () => {
    dispatch(showLoading());
    if (selectedContract.id) {
      client()
        .query({
          query: GET_DASHBOARD_CONSUMPTIONS_AS_XLS,
          variables: {
            contractId: selectedContract.id,
          },
        })
        .then((data: any) => {
          console.log(data.data.getDashboardConsumptionsAsXls, "data excel");
          dispatch(hideLoading());
          window.open(data.data.getDashboardConsumptionsAsXls.path, "_blank");
        })
        .catch((err: any) => {
          dispatch(hideLoading());
          console.log(err, "err excel");
        });
    }
  };

  const setHeroShowPopup = useCallback(() => setShowPopup(false), []);
  return (
    <>
      <div className="ViewUsages" data-testid="ViewUsages">
        <Hero
          showPopup={showPopup}
          helpText={t("usage.modal.text")}
          backTo={"/"}
          backToText={t("common.back.home")}
          title={t("usages.header")}
          parentClosesModal={setHeroShowPopup}
          description={
            <div>
              <p>{t("usages.title")}</p>
              <Link to={"/selfread-add"}>{t("usages.link")}</Link>
            </div>
          }
        />

        <div className="container component">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <h2 className="headline-bold-fs3">
                {t("usages.header.contract")}
              </h2>
            </div>
          </div>
        </div>

        <div className="container component">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="drop-down">
                <ContractsSelect
                  usages={true}
                  label={t("usages.contractSelect")}
                />
              </div>
            </div>
          </div>
        </div>

        {contracts.length === 0 ? (
          <NoResult text={t("usage.empty.text")} />
        ) : null}

        {contracts.length > 0 ? (
          <div className="container component contract-box">
            <div className="row">
              <div className="col-sm-12 col-md-12">
                <div className="box-container">
                  <div className="box-table">
                    <div className="box-title headline-bold-fs3">
                      {t("usage.contactData")}
                    </div>
                    <div className="tab-container">
                      {counterData.map((element: any, index: any) => {
                        return (
                          <div className="tab-elements" key={element.label}>
                            <h4
                              id={element.label}
                              className="header-text  paragraph-small-fs9"
                            >
                              {element.label}
                            </h4>
                            <span
                              aria-labelledby={element.label}
                              className="data-text paragraph-large-fs7"
                            >
                              {element.data
                                ? element.data
                                : t(
                                    "dashboard.header.info.meter.not.available"
                                  )}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {contracts.length > 0 && (
          <div className="grafic-box">
            <div className="container component ">
              <div className="row">
                <div className="col-sm-12 col-md-12">
                  {/* Navigation Tabs */}
                  <Nav
                    activeKey={key}
                    onSelect={setTabsKey}
                    className="nav-tabs"
                    role="tablist"
                  >
                    {telemeter && (
                      <Nav.Item>
                        <Nav.Link
                          as="button"
                          eventKey="grafico consumi"
                          id="tab-grafico"
                          aria-controls="panel-grafico"
                          role="tab"
                          aria-selected={key === "grafico consumi"}
                        >
                          {t("usages.tabs.type.consumptionGraph")}
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    <Nav.Item>
                      <Nav.Link
                        as="button"
                        eventKey="consumi fatturati"
                        id="tab-fatturati"
                        aria-controls="panel-fatturati"
                        role="tab"
                        aria-selected={key === "consumi fatturati"}
                      >
                        {t("usages.tabs.type.billedConsumption")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  {}
                  {telemeter && key === "grafico consumi" && (
                    <div
                      id="panel-grafico"
                      role="tabpanel"
                      aria-labelledby="tab-grafico"
                      aria-hidden={key !== "grafico consumi"}
                      className="tab-content"
                    >
                      {loadChart && (
                        <ConsumeChart contract={selectedContract} />
                      )}
                      <div className="gcap-cta gcap-cta--hoverize-2">
                        <button
                          className="btn btn-primary btn--icon"
                          onClick={handleExportExcel}
                          data-testid="ArrowLinkWithAction"
                        >
                          {t("cta.export.excel")}
                          <svg
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M15.53 15.0329C15.6662 15.0329 15.7786 15.0819 15.8672 15.18C15.9557 15.2781 16 15.3903 16 15.5164C16 15.6566 15.9557 15.7722 15.8672 15.8633C15.7786 15.9544 15.6662 16 15.53 16H0.469987C0.333759 16 0.221371 15.9544 0.132822 15.8633C0.0442742 15.7722 0 15.6566 0 15.5164C0 15.3903 0.0442742 15.2781 0.132822 15.18C0.221371 15.0819 0.333759 15.0329 0.469987 15.0329H15.53ZM8.01022 0C8.13282 0 8.24181 0.0490583 8.33716 0.147175C8.43252 0.245291 8.4802 0.357424 8.4802 0.483574V11.9212L12.7305 7.54796C12.8123 7.44985 12.9178 7.40079 13.0473 7.40079C13.1767 7.40079 13.2891 7.44985 13.3844 7.54796C13.4798 7.63206 13.5275 7.74069 13.5275 7.87385C13.5275 8.00701 13.4798 8.12265 13.3844 8.22076L8.33716 13.435C8.2963 13.463 8.25883 13.4875 8.22478 13.5085C8.19072 13.5296 8.15326 13.5471 8.11239 13.5611H7.96935H7.88761C7.84674 13.5471 7.80928 13.5296 7.77522 13.5085C7.74117 13.4875 7.7037 13.463 7.66284 13.435L2.61558 8.22076C2.52022 8.12265 2.47254 8.00701 2.47254 7.87385C2.47254 7.74069 2.52022 7.63206 2.61558 7.54796C2.71094 7.44985 2.82333 7.40079 2.95275 7.40079C3.08216 7.40079 3.19455 7.44985 3.28991 7.54796L7.5198 11.9212V0.483574C7.5198 0.357424 7.56748 0.245291 7.66284 0.147175C7.75819 0.0490583 7.87399 0 8.01022 0Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                  {key === "consumi fatturati" && (
                    <div
                      id="panel-fatturati"
                      role="tabpanel"
                      aria-labelledby="tab-fatturati"
                      aria-hidden={key !== "consumi fatturati"}
                      className="tab-content"
                    >
                      <DataTable columns={columns} data={listContract} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

ViewUsages.propTypes = {};

export default ViewUsages;
